import { AbstractInterface } from './AbstractInterface';
import { ApplicationConfig } from '../application/baseApplication';
import { IACMessageData } from '../transport/iacProtocol';

export interface NavigatorConfig {
  apps?: {
    [key: string]: ApplicationConfig;
  };
  external_redirect_url?: string;
  logout_apps_url?: string;
  logout_url?: string;
  notifynavigatorService?: {
    context_token?: string;
    trinity_update_apps?: string[];
  };
  resolve_app_data_url?: string;
  resolve_app_url?: string;
  resolve_apps_data_url?: string;
  resolve_reinit_url?: string;
  session_expired_url?: string;
  startup?: {
    toolbarevent?: string;
    usecases?: {
      [key: string]: IACMessageData;
    }
  };
  theme?: string;
  tracking?: any; // not used in Atlas
  user?: {
    origin?: any;
    payuser?: boolean;
  };
}

export class NavigatorInterface extends AbstractInterface {

  public static hide(): void {
    this.mediator.hideNavBar();
  }

  public static show(): void {
    this.mediator.showNavBar();
  }

}
